import superagent from 'superagent';
import { getUserToken } from 'utils/authHeader';
import { unauthorizedRedirect } from 'utils/unauthorizedRedirect';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listOneclick = async ({ limit, page }) => {
  let portfolioApi = superagent
    .get(`${BASE_URL}/oneclick/list`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .query({ page })
    .query({ limit });
  return await portfolioApi;
};

export const addOneclick = async (payload) => {
  return await superagent
    .post(`${BASE_URL}/oneclick/create`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};

export const editOneclick = async (payload) => {
  return await superagent
    .put(`${BASE_URL}/oneclick/edit`)
    .set('Authorization', `Bearer ${getUserToken()}`)
    .set('Content-Type', 'application/json')
    .use(unauthorizedRedirect)
    .send(payload)
    .retry(2);
};
